<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<template>
  <div class="one-column-width">
    <!-- form start -->
    <v-card class="r_tabsform_card mb-5">
      <v-card-title class="r_form_card_title ext_pdg_to_lvl">
        Find Mentor</v-card-title
      >
      <hr class="r_form_card_top_hr" />

      <div class="m-5 row">
        <div class="col-md-3">
          <!-- <label>Name <span class="text-danger">*</span></label> -->
          <multiselect
            class="slect_home_hero overflow-x-h w-100"
            v-model="selected_programs"
            :height="300"
            :options="allPrograms"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Program"
            label="value"
            track-by="value"
            :preselect-first="false"
          >
          </multiselect>
        </div>

        <div class="col-md-3">
          <!-- <label>Institute <span class="text-danger">*</span></label> -->
          <multiselect
            class="slect_home_hero overflow-x-h w-100"
            v-model="selected_levels"
            :height="300"
            :options="allLevels"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Level"
            label="value"
            track-by="value"
            :preselect-first="false"
          >
          </multiselect>
        </div>

        <div class="col-md-3">
          <!-- <label>Institute <span class="text-danger">*</span></label> -->
          <!-- <input type="text" class="r_formtabs_inputs m-0 w-100" placeholder="Semester/Class" /> -->
          <multiselect
            class="slect_home_hero overflow-x-h w-100"
            v-model="selected_semesters"
            :height="300"
            :options="semesters"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Semester/Class"
            label="value"
            track-by="value"
            :preselect-first="false"
            :disabled="in_progress == 0 || in_progress == false"
          >
          </multiselect>
        </div>

        <div class="col-md-3">
          <input
            type="checkbox"
            id="in_progress"
            v-model="in_progress"
            class="mr-3"
            :checked="in_progress == 1 || in_progress == true"
          />
          <label for="in_progress">In Progress</label>
        </div>

        <div class="col-md-3 pt-2">
          <button
            type="button"
            class="r_form_add_more_btnnn m-0"
            @click="submitSearch"
          >
            Search
          </button>
        </div>
      </div>
    </v-card>
    <!-- form end -->

    <!-- table start -->
    <v-card class="r_tabsform_card">
      <v-card-title class="r_form_card_title">
        Search Result

        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          class="r_form_top_search"
          label="Search Uni Mates"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <hr class="r_form_card_top_hr" />

      <v-data-table
        class="r_admn_dashboad_tdss"
        :headers="headers"
        :items="tableData"
        :search="search"
        loading
      >
        <template v-slot:[`item.actions`]="{ item }">
          <button
            class="btn btn-sm btn-primary"
            fab
            small
            @click="showEditForm(item)"
          >
            Send Request
            <!-- <v-icon class="text-success">fas fa-edit fa-lg</v-icon> -->
          </button>
          <!-- &nbsp;
          <v-btn
            class="btn btn-sm btn-light font-weight-bold py-3 px-3 px-xxl-5 my-1"
            fab
            small
            @click="askUserAboutDelete(item)"
          >
            <v-icon class="text-danger">mdi-delete</v-icon>
          </v-btn> -->
        </template>
      </v-data-table>
    </v-card>

    <!-- table end -->
  </div>
</template>

<script>
import AdmissionForm from "@/MainServices/AdmissionForm.js";
import { mapGetters, mapState } from "vuex";
import Multiselect from "vue-multiselect";
import GeneralService from "@/MainServices/GeneralService.js";
import axios from "axios";
import API from "@/core/api";

export default {
  data() {
    return {
      educations: [],
      allLevels: [],
      allPrograms: [],
      selected_levels: [],
      selected_programs: [],
      semesters: [
        { id: 1, value: 1 },
        { id: 2, value: 2 },
        { id: 3, value: 3 },
        { id: 4, value: 4 },
        { id: 5, value: 5 },
        { id: 6, value: 6 },
        { id: 7, value: 7 },
        { id: 8, value: 8 },
        { id: 9, value: 9 },
        { id: 10, value: 10 },
      ],
      selected_semesters: [],
      in_progress: 0,
      token: `Bearer ${localStorage.getItem("token")}`,
      editId: null,
      deleteId: null,
      dialog: false,
      snackbar: false,
      snackBarText: null,
      deleting: false,
      errorMessage: false,
      search: "",
      showFormData: false,
      applicationValues: null,
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "user.name",
          width: "15%",
          class: "r_admn_dashboad_title",
        },
        {
          text: "Program",
          align: "left",
          sortable: false,
          value: "program.program",
          width: "15%",
          class: "r_admn_dashboad_title",
        },
        {
          text: "Level",
          align: "left",
          sortable: false,
          value: "level.level",
          width: "15%",
          class: "r_admn_dashboad_title",
        },
        {
          text: "Institute",
          align: "left",
          sortable: false,
          value: "institute.name",
          width: "25%",
          class: "r_admn_dashboad_title",
        },
        {
          text: "Status",
          align: "left",
          sortable: false,
          value: "status",
          width: "15%",
          class: "r_admn_dashboad_title",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          class: "r_admn_dashboad_title",
        },
      ],
      tableData: [],
    };
  },
  components: { Multiselect },

  computed: {
    ...mapGetters(["currentUser"]),
  },

  methods: {
    // getInititalData() {
    //   AdmissionForm.getStudentApplications()
    //     .then((res) => {
    //       this.tableData = res.data;
    //     })
    //     .catch(() => {
    //       this.loading = false;
    //     });
    // },

    submitSearch() {
      let programs = [];
      let levels = [];
      let semesters = [];

      this.selected_programs.map((el) => {
        programs.push(el.id);
      });

      this.selected_levels.map((el) => {
        levels.push(el.id);
      });
      this.selected_semesters.map((el) => {
        semesters.push(el.id);
      });

      let formData = new FormData();

      for (var i = 0; i < programs.length; i++) {
        formData.append("selected_programs[]", programs[i]);
      }
      for (var i = 0; i < levels.length; i++) {
        formData.append("selected_levels[]", levels[i]);
      }
      for (var i = 0; i < semesters.length; i++) {
        formData.append("selected_semesters[]", semesters[i]);
      }
      formData.append("in_progress", this.in_progress);

      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .post(`${API.API_URL}/std-mentor-profile-search`, formData)
        .then((res) => {
          this.tableData = res.data;
        })
        .catch((err) => {});
    },
  },
  mounted() {
    // this.getInititalData();

    GeneralService.getStdCareerProfle()
      .then((res) => {
        if (res.data) {
          if (res.data.educations.length > 0) {
            this.educations = [];
            for (let i = 0; i < res.data.educations.length; i++) {
              this.educations.push({
                level: res.data.educations[i].level.level,
                program: res.data.educations[i].program.program,
                startDate: res.data.educations[i].start_date,
                endDate: res.data.educations[i].end_date,
                institute: res.data.educations[i].institute,
                inProgress: res.data.educations[i].in_progress,
                obtainedMarks: res.data.educations[i].obtained_marks,
                grades: res.data.educations[i].grades,
              });
            }
          }
        }

        if (res.data.allLevels.length > 0) {
          this.allLevels = [];
          res.data.allLevels.map((el) => {
            this.allLevels.push({ id: el.id, value: el.level });
          });
        }

        if (res.data.allPrograms.length > 0) {
          this.allPrograms = [];
          res.data.allPrograms.map((el) => {
            this.allPrograms.push({ id: el.id, value: el.program });
          });
        }
      })
      .catch((error) => {
        // console.log("error", error);
      });
  },
};
</script>

<style scoped>
.text-success {
  color: #2eca8b !important;
}
.text-danger {
  color: #a82511 !important;
}
</style>
